import { render, staticRenderFns } from "./DeadlineBanner.vue?vue&type=template&id=0788ea80&scoped=true"
import script from "./DeadlineBanner.vue?vue&type=script&lang=js"
export * from "./DeadlineBanner.vue?vue&type=script&lang=js"
import style0 from "./DeadlineBanner.vue?vue&type=style&index=0&id=0788ea80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0788ea80",
  null
  
)

export default component.exports